import React, { useState } from 'react';

// Components
import { ErrorMessage } from '../ErrorMessage';

// Utils
import { stripNonDigits } from '../../utilities/inputs';

interface EditInputProps {
  label: string;
  name: string;
  type?: 'text' | 'email' | 'tel' | 'number';
  onlyNumbers?: boolean;
  disablePaste?: boolean;
  errorMessage?: string;
  defaultValue?: string | undefined;
  autoComplete?:
    | 'off'
    | 'on'
    | 'name'
    | 'given-name'
    | 'family-name'
    | 'email'
    | 'username'
    | 'street-address'
    | 'country-name'
    | 'postal-code'
    | 'tel';
  onChange: (name: string, value: string) => void;
}

export const EditInput: React.FC<EditInputProps> = ({
  name,
  label,
  type = 'text',
  defaultValue,
  errorMessage,
  onChange,
  onlyNumbers = false,
  autoComplete = 'on',
  disablePaste = false
}) => {
  const [value, setValue] = useState<string>(defaultValue || '');

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    // if the type is numbers then we don't allow any whitespace
    const updatedValue = onlyNumbers === true ? stripNonDigits(value) : value;
    setValue(updatedValue);
    onChange(name, updatedValue);
  };

  const formControlClasses = `form-control ${errorMessage ? 'form-control--error' : ''}`;

  return (
    <div>
      <label htmlFor={name} className="form-label">
        {label}
      </label>
        <input
          className={formControlClasses}
          id={name}
          type={type}
          name={name}
          value={value}
          onPaste={(e) => {
            if (disablePaste) {
              e.preventDefault();
            }
          }}
          onChange={handleOnChange}
          autoComplete={autoComplete}
        />
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};
